<template>
    <!-- 军事/公安类升学(民航招飞，海军招飞，空军招飞，军校招生，公安院校，航海类院校) -->
    <!-- 公安院校 -->
    <div class="police_school studyway_common_father">
        <h5>公安院校及报考条件</h5>
        <div class="question">
            <h6 class="title">问题一：公安院校有哪些?</h6>
            <div class="main">
                <p>公安类普通高等院校(32所)： 中国人民公安大学 中国刑事警察学院 铁道警察学院 南京森林警察学院 (以上四所为公安部直属)</p>
                <p>北京警察学院 天津公安警官职业学院 河北公安警察职业学院 山西警官高等专科学校 内蒙古警察职业学院 辽宁警察学院 吉林警察学院 黑龙江公安警官职业学院 上海公安高等专科学校 江苏警官学院 浙江警察学院 安徽公安职业学院 福建警察学院 江西警察学院 山东警察学院 河南警察学院 湖北警官学院 湖南警察学院 广东警官学院 广西警察学院 重庆警察学院 四川警察学院 贵州警官职业学院 云南警官学院 西藏警官高等专科学校 甘肃警察职业学院 青海警官职业学院 新疆警察学院</p>
                <p>公安专业： 本科专业(18个)： 治安学、侦查学、国内安全保卫、刑事科学技术、公安视听技术、经济犯罪侦查、警犬技术、公安管理学、涉外警务、安全防范工程、交通管理工程、警务指挥与战术、禁毒学、犯罪学、公安情报学、网络安全与执法、消防指挥、消防工程。</p>
                <p>专科专业(13个)： 治安管理、交通管理、信息网络安全监察、特警、警察管理、公共安全管理、警察指挥与战术、刑事科学技术、警犬技术、刑事侦查、国内安全保卫、经济犯罪侦查、禁毒</p>
            </div>    
        </div>
        <div class="question">
            <h6 class="title">问题二：哪些考生有资格报考公安院校?</h6>
            <p>报考公安院校及专业的考生，必须参加普通高校招生全国统一考试，除符合普通高校招生报名规定外，还应具备从事公安工作所要求的下列条件。</p>
            <div class="condition">
                <p class="condition_title">一、报考条件</p>
                <ul class="condition_detail">
                    <li>1、拥护四项基本原则，热爱祖国，热爱人民，遵纪守法，勤奋学习，志愿献身公安事业;</li>
                    <li>2、高中毕业;</li>
                    <li>3、身体健康，符合从事相关公安工作所要求的条件;</li>
                    <li>4、未婚，年龄不超过22周岁(其中报考中国人民武装警察部队学院、公安海警学院的考生，必须是高中应届毕业生，年龄不超过20周岁。如2017届考生应在1997年8月31日后出生)。</li>
                </ul>
            </div>
            <div class="condition">
                <p class="condition_title">二、政治条件 </p>
                <p class="condition_detail">凡报考公安普通高等学校的考生，除按《2000年普通高等学校招生工作规定》第5条、第6条规定的政治思想品德考核标准进行考核外，还必须经过公安机关的政治审查。强调考生本人思想进步、品德优良、作风正派，有较强的组织纪律性和法制观念。 有下列情形之一的，属政审不合格： 有反对四项基本原则言行的; 有流氓、偷窃等不良行为，道德品质不好的; 有犯罪嫌疑尚未查清的; 直系血亲或对本人有较大影响的旁系血亲在境外、国外从事危害我国国家安全活动，本人与其划不清界限的; 直系血亲中或对本人有较大影响的旁系血亲中有被判处死刑或者正在服刑的; 其他原因不宜做人民警察的。</p>
            </div>
            <div class="condition">
                <p class="condition_title">三、身体条件  </p>
                <p class="condition_detail">报考公安普通高校的考生除执行普通高等学校招生身体健康状况标准外，考生还应符合下列条件： 男性考生身高一般不低于1.70米，体重不低于50公斤;女性考生身高一般不低于1.60米，体重不低于45公斤;身体匀称;并根据人事部、公安部下发的《公安机关录用人民警察体检项目和标准》中的有关规定，对于过于肥胖或消瘦的考生(标准〈千克〉=身高〈厘米〉-110，实际体重超过标准体重25%以上者为过于肥胖者，实际体重低于标准体重15%以上者为过于消瘦)按体检部格论。 左右眼单眼裸视力，理科类专业应在4.9(0.8)以上，文科类专业应在4.8(0.6)以上。无色盲、色弱;两耳无重听;无口吃; 五官端正，面部无明显特征和缺陷(如唇裂、对眼、斜眼、斜颈、各种疤麻等)，嗅觉不迟钝、鸡胸、无腋臭，无严重静脉曲张，无明显八字步、罗圈腿，无重度平跖足(平脚板)，无纹身、少白头、驼背，无各种残疾，直系血亲无精神病史。 无传染病，肝功化验指标必须在正常范围内，无甲肝、乙肝、澳抗阳性。 体能测试成绩合格，体能测试项目及标准： 男生：50米7秒1以内(含7秒1);1000米3分55秒以内(含3分55秒);俯卧撑10秒内完成6次以上(含6次);立定跳远2.3米以上(含2.3米)。 女生：50米8秒6以内(含8秒6);800米3分50秒以内(含3分50秒);仰卧起坐10秒内完成5次以上(含5次);立定跳远1.6米以上(含1.6米)</p>
            </div>
        </div>
        <div class="question">
            <h6 class="title">问题三：公安类院校录取分数线高吗?</h6>
            <div class="main">
                <p>一般而言，报考中国人民公安大学、中国刑事警察学院(警犬技术专业除外)和中国人民武装警察部队学院的考生，高考成绩须达到当地一批本科录取最低控制分数线; 报考中国刑事警察学院警犬技术专业、中央司法警官学院、公安海警学院、铁道警察学院(本科专业)、南京森林警察学院，以及各省警察(警官)学院的考生，</p>
                <p>高考成绩须达到二批本科录取最低控制分数线; 报考铁道警察学院(专科专业)的考生，高考成绩须达到三批本科最低控制分数线; 西北政法大学、西南政法大学的公安本科专业在录取时执行其在普通本科录取批次的分数线。 公安类院校的志愿如何填报? 公安院校及专业志愿填报在提前录取批次，本科志愿填报在“提前本科批次A段”栏内，专科志愿填报在“提前专科”栏内。 公安部所属各院校面向贫困地区专项招生，安排在提前批次A段，与公安院校同时投档录取。 公安院校及专业招生必须遵循本校招生章程中公布的录取规则(女生比例不超过15%)。按照“学校负责，招办监督”的原则进行录取。</p>
            </div>    
        </div>
        <div class="question">
             <h6 class="title">问题四：公安院校或公安类专业毕业生，一定能当上警察吗？</h6>
             <div class="main">
                 <p>几率很大，但是毕业后必须参加公安院校和公安专业毕业生招录考试。 公安院校公安专业毕业生(含研究生)招考工作实行全国统一考试，分省(区、市)录用的办法。每年定期统一组织笔试，分省(区、市)确定录用计划、划定分数线、组织面试、体检、考察和录用</p>
                 <p>(一)制定录用计划 各省级公安机关综合考虑当年部属公安院校本地生源和本地公安院校毕业生规模，按照当年本地公安机关录用人民警察计划的一定比例编制公安院校公安专业毕业生录用计划，主要充实到执法勤务机构。录用计划报省级公务员主管部门审定。</p>
                 <p>(二)报名与资格审查 招考对象为公安院校公安专业应届毕业生。报考人员应当符合人民警察的招考资格条件。省级公安机关负责组织资格审查工作，并将审查结果在公安院校进行公示。公安院校要如实提供有关信息，配合做好有关工作。省级公务员主管部门对资格审查工作进行监督。</p>
                 <p>(三)统一组织笔试 每年统一组织笔试。笔试包括公共科目和专业科目，公共科目和专业科目按一定比例合成笔试总成绩。公共科目试题由国家公务员局负责组织命制，专业科目试题由公安部负责组织命制。考务工作由省级公务员主管部门负责。</p>
                 <p>(四)划定笔试合格分数线 2016年—2019年毕业的公安院校公安专业毕业生，根据实际情况在现有基础上逐步提高入警比例。2020年以后毕业的公安院校公安专业毕业生，由省级公务员主管部门会同省级公安机关，根据公安院校教学质量评估情况，结合实际确定入警比例，并据此划定合格分数线。部属院校公安专业毕业生纳入生源省或拟报考省一并划线。</p>
                 <p>(五)开展面试等工作 省级公务员主管部门、省级公安机关按照管理权限在相对集中的时间、地点对笔试合格的考生进行面试、体检、体能测评、考察等相关工作。体检、体能测评、考察的合格标准按公安机关统一招警标准执行。</p>
                 <p>(六)选择招录职位 部属院校和省属院校公安专业毕业生原则上回生源地(本行业)公安机关入警。笔试、面试、体检、体能测评、考察等均合格的毕业生，原则上按照笔试总成绩由高到低的顺序选择职位。职位选择工作由省级公务员主管部门负责组织。</p>
                 <p>(七)办理录用手续 省级公务员主管部门或设区的市级公务员主管部门按有关规定为新录用人员办理录用审批手续。新录用的公安院校公安专业毕业生在录用单位的最低服务年限为 5年(含试用期)，其中，录用到基层一线执法单位的人员在此期间不得转任交流到公安基层一线执法单位以外的单位。</p>
                 <p>本网站的信息及数据主要来源于网络及各院校网站，本站提供此信息之目的在于为高考生提供更多信息作为参考，由于各方面情况的不断调整与变化，敬请以权威部门公布的正式信息为准</p>
            </div>      
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {
            universities: [

            ]
        }
    },
    methods: {
        goUniversity(id) {
            var id = id;
            let {href}=this.$router.resolve({
                path: '/yuanxiaoxiangqing',
                name: 'yuanxiaoxiangqing',
                query: {
                    id: id,
                }
            })
            window.open(href, '_blank');
        }
    },
    created() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
    .police_school {
        background-color: #fff;
        padding: 0px 20px;
        padding-bottom: 30px;
        font-size: 14px;
        h5 {
            line-height: 70px;
            font-size: 24px;
            color: #333;
            text-align: center;
            font-weight: 600;
            border-bottom: 1px solid #dedede;
        }
        .question {
            h6 {
                font-size: 18px;
                color: #2c8ffc;
                line-height: 60px;
            }
            .main {
                padding-left: 2em;
                p {
                    text-indent: 2em;
                    margin-bottom: 10px;
                }
            }
            .condition {
                padding-left: 2em;
                .condition_title {
                    font-size: 16px;
                    color: #333;
                    line-height: 40px;
                }
                .condition_detail {
                    padding-left: 2em;
                    li {
                        line-height: 24px;
                    }
                }
            }          

        }
    }
</style>